import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@components/atoms/Card';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { formatPrice } from '@utils/format';
import { ProductBase } from '@types';
import styles from './ConfirmProductCard.module.css';

interface ConfirmProductCardProps extends ProductBase {
    merchant: string;
    quantity: number;
}

export const ConfirmProductCard: FC<ConfirmProductCardProps> = ({ name, image, merchant, price, quantity }) => {
    const { t } = useTranslation();

    const translations = {
        sentByLabel: t('confirm-product-card-component.sent-by.label'),
        quantityLabel: t('confirm-product-card-component.quantity.label'),
    };

    return (
        <Card classes={styles['confirm-product-card']}>
            <div className="d-flex gap-4">
                <div>
                    <img className={styles['image']} src={image} alt={name} />
                </div>
                <div className="d-grid pt-2 pt-md-0">
                    <Card.Title
                        typography={{
                            classes: 'text-truncate mb-0',
                            fontSize: '14',
                            color: 'dark',
                            fontWeight: '900',
                            breakpointsStyles: { md: { fontSize: '16' } },
                            children: name,
                        }}
                    />
                    <Typography
                        classes="mb-0"
                        fontSize="20"
                        color="primary"
                        fontWeight="800"
                        breakpointsStyles={{ md: { fontSize: '24' } }}>
                        {formatPrice(price)}
                    </Typography>

                    <Typography classes="text-truncate mb-0 mb-md-1" fontSize="14">
                        <>
                            {`${translations.sentByLabel} `}
                            <Typography tagVariant={TypographyTagVariants.span} fontWeight="900">
                                {merchant}
                            </Typography>
                        </>
                    </Typography>

                    <Typography classes="mb-0" fontSize="14" color="muted">
                        {`${translations.quantityLabel} ${quantity}`}
                    </Typography>
                </div>
            </div>
        </Card>
    );
};
